export const distance = (a: number, b: number) => Math.abs(a - b);

export const clamp = (min: number, max: number, v: number) => Math.min(Math.max(v, min), max);
